// extracted by mini-css-extract-plugin
export default {"loaderContainer":"sliderLoader_loaderContainer__v6rmN","loaderBar":"sliderLoader_loaderBar__bilhS","slide":"sliderLoader_slide__TbJ0D"};